import React, { useEffect, useMemo } from 'react';
import { Col } from 'react-bootstrap5';

import Select from 'components/new_ui/Select';
import { useContext as useTeamsContext } from 'components/Managers/Teams/Context';
import { useContext as useCyclesContext } from 'components/Cycles/Context';
import { useContext } from 'components/Managers/Dashboard/Context';

export default function CycleFilter() {
  const { dispatch, actions, state: { filters } } = useContext();
  const { state: stateTeams } = useTeamsContext();
  const {
    dispatch: dispatchCycles,
    actions: actionsCycles,
    state: stateCycles,
  } = useCyclesContext();

  useEffect(() => {
    if (filters.teamId && filters.teamId.length === 1) {
      actionsCycles.load(dispatchCycles, filters.teamId[0]);
    }
  }, [filters.teamId]);

  const displayCycleFilter = useMemo(() => (
    filters.teamId === null || filters.teamId.length === 0
      || filters.teamId.length > 1 ? false : (stateTeams.teams && filters.teamId
        && filters.teamId.every((teamId) => stateTeams.teams.find(
          (team) => team.id === teamId && team.attributes.voluntary_benefit,
        )))
  ), [filters.teamId]);

  if (!displayCycleFilter) {
    return null;
  }

  const cyclesFilterOptions = stateCycles.cycles && stateCycles.cycles.map(
    (cycle) => ({ label: cycle.attributes.title, value: cycle.id }),
  );

  return (
    <Col>
      <div className="form-label">Cycle</div>
      <Select
        id="cycle-id-filter"
        placeholder="All"
        isLoading={stateCycles.cycles === null}
        value={filters.cycleId ? undefined : null}
        options={cyclesFilterOptions || []}
        onChange={(selectedOption) => actions.setCycleFilter(dispatch, filters, selectedOption)}
      />
    </Col>
  );
}
